import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';

import ReservationDates from 'components/Offers/Filters/ReservationDates/ReservationDates';
import {Reservation} from 'models/Reservations';
import {OffersActions} from 'store/offers/offers.reducer';
import {selectedReservationConfirmationCodeSelector} from 'store/offers/offers.selectors';
import {threeSoonestValidReservationsSelector} from 'store/reservations/reservations.selectors';

export const ConnectedReservationDates = () => {
  const reservations = useSelector(threeSoonestValidReservationsSelector);
  const selectedReservationCC = useSelector(
    selectedReservationConfirmationCodeSelector
  );

  const dispatch = useDispatch();
  const handleReservationPress = useCallback(
    (reservation: Reservation) => {
      dispatch(OffersActions.reservationSelected(reservation));
    },
    [dispatch]
  );

  return (
    <ReservationDates
      reservationDates={reservations}
      selectedReservationConfirmationCode={selectedReservationCC}
      onReservationPress={handleReservationPress}
    />
  );
};
